import { Page } from '@app/components/page/Page';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import { Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { useOptionalNotificationsSessionContext } from '../session/useNotificationsSessionContext';
import { NotificationPreferencesEditor } from './NotificationPreferencesEditor';
import {
  notificationPreferencesTitleMessage,
  notificationPreferencesUnavailableMessage,
} from './notification-preferences-messages';

/**
 * User settings page for per-workflow notification preferences (supported channels only).
 */
export function NotificationPreferencesPage() {
  const { formatMessage } = useIntl();
  const session = useOptionalNotificationsSessionContext();
  const title = formatMessage(notificationPreferencesTitleMessage);

  return (
    <Page htmlTitle={title}>
      <Page.Header icon={<NotificationsOutlinedIcon />} title={title} />
      <Page.Content maxWidth="md">
        {session?.isKnockReady ? (
          <NotificationPreferencesEditor />
        ) : (
          <Typography variant="body2" color="text.secondary">
            {formatMessage(notificationPreferencesUnavailableMessage)}
          </Typography>
        )}
      </Page.Content>
    </Page>
  );
}
